// extracted by mini-css-extract-plugin
module.exports = {"bkw-I":"I_bkw-I__DeWwR"};